import React from 'react';

export function renderPromoText(text: string) {
  const segments: Array<{ bold: boolean; text: string }> = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ bold: false, text: text.slice(lastIndex, match.index) });
    }
    segments.push({ bold: true, text: match[1] });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    segments.push({ bold: false, text: text.slice(lastIndex) });
  }
  if (!segments.length) {
    return text;
  }
  return segments.map((segment, index) =>
    segment.bold ? (
      <strong key={index} className="chunkzters-hero-promo-strong">
        {segment.text}
      </strong>
    ) : (
      <React.Fragment key={index}>{segment.text}</React.Fragment>
    )
  );
}

export function HeroPromoText({ text }: { text: string }) {
  return (
    <div className="chunkzters-hero-promo mt-3" role="status" aria-live="polite">
      <span className="chunkzters-hero-promo-badge">
        <i className="bi bi-tag-fill" aria-hidden />
        {renderPromoText(text)}
      </span>
    </div>
  );
}
